import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import Row from './row';
import { getBrokerageGrossCommissionAmount } from './helpers';
import { USD } from 'helpers/formatters/number_formats';

export function TransactionSideCardDeductions({ deal, transactionSide }) {
  const deductions = deal.deductions.filter((deduction) => {
    return !deduction.deductFromHouse && deduction.transactionSideDetail.transactionSide === transactionSide;
  });

  if (!deductions.length) {
    return null;
  }

  const totalDeduction = deductions.reduce((sum, deduction) => deduction.amount + sum, 0);
  const remainingGrossAmount = getBrokerageGrossCommissionAmount(deal, transactionSide) - totalDeduction;

  return <React.Fragment>
    <Row borderBottom borderTop label="Pre-Split Deductions" value={USD.format(totalDeduction)} />
    <Row borderBottom borderTop label="Remaining Gross" value={USD.format(remainingGrossAmount)} />
  </React.Fragment>;
}

TransactionSideCardDeductions.propTypes = {
  deal: PropTypes.shape({
    deductions: PropTypes.arrayOf(PropTypes.shape({
      amount: PropTypes.number.isRequired,
      deductFromHouse: PropTypes.bool,
      transactionSideDetail: PropTypes.shape({
        transactionSide: PropTypes.string.isRequired,
      }).isRequired,
    })).isRequired,
  }).isRequired,
  transactionSide: PropTypes.string.isRequired,
};

const mapStateToProps = state => ({
  deal: state.deal,
});

export default connect(mapStateToProps)(TransactionSideCardDeductions);
